'use strict';
const angular = require('angular');

export class SingleAddressLabelModalComponent {
  /*@ngInject*/
  constructor($scope, CommunityService, $uibModal, SettingsService) {
    this.$scope = $scope;
    this.$uibModal = $uibModal;

    this.model = {
      position: 1
    };
    this.$scope.model = this.model;

    this.positions = [];
    for (let i=1; i<=30; i++)
      this.positions.push(i);

    this.mapFileType = {
      'docx': "Word Document (DOCX)",
      'odt': 'Open Office Document (ODT)',
      'pdf': 'Portable Document Format (PDF)'
    };

    SettingsService.getByName({name: "client"}, settings => {
      this.model.template = settings.data.templates["single-address-label"];
    });

    /*
    CommunityService.query(data => {
      this.communities = data.map(community => {
        return {
          value: community._id,
          name: community.code + ": " + community.name
        }
      });
    });

     */

    $scope.$watch("model", _ => this.filterb64 = btoa(JSON.stringify(this.model)), true);
  }
/*
  communityLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'communityLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (community) {
        that.model.community = community._id;
      },
      function () { }
    );

  }
*/

  getAddress(address) {
    try {
      return `${address.street}, ${address.city} ${address.state}, ${address.zip}`;
    } catch (e){
      return "-";
    }
  }

  $onInit() {
    this.config = this.resolve.config;
//    this.icon = this.config.icon || 'download';
//    this.fields = this.config.filter || [];

    let filetypes = this.config.fileTypes || ["docx", "pdf", "odt"];
    this.fileTypes = filetypes.map(fileType => { return {fileType: fileType, name: this.mapFileType[fileType]} });

    this.addresses = this.config.addresses.map(adr => {

      let primaryMark = adr.isPrimary ? " (Primary)" : "";

      if (adr.isPrimary)
        this.model.address = adr;

       return {
         name: this.getAddress(adr) + " (" + adr.type + ")" + primaryMark,
         json: adr
       }
    });

    this.model.report = "single-address-label";
    this.model.fileType = this.config.defaultFileType || "docx";

    this.model.owner = this.config.owner;

    this.filterb64 = btoa(JSON.stringify(this.model));
  };

  ok(model) {
    this.close({$value: model});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      this.ok(this.model);
    }
  }
}

export default angular.module('conduu.singleAddressLabelModal', [])
  .component('singleAddressLabelModal', {
    template: require('./single-address-label-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: SingleAddressLabelModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/single-address-label-modal/single-address-label-modal.component.js